import { Button } from '@vibe/core';
import { useTranslation } from '@/i18n/useTranslation';
import styles from './WizardNav.module.css';

export interface WizardNavProps {
  currentStep: number;
  isLastStep: boolean;
  canProceed: boolean;
  loading?: boolean;
  nextLabel?: string;
  /** Show back on step 0 (e.g. return to map in journey flow). */
  showBackOnFirstStep?: boolean;
  onBack: () => void;
  onNext: () => void;
}

export default function WizardNav({
  currentStep,
  isLastStep,
  canProceed,
  loading = false,
  nextLabel,
  showBackOnFirstStep = false,
  onBack,
  onNext,
}: WizardNavProps) {
  const t = useTranslation();
  const showBack = currentStep > 0 || showBackOnFirstStep;

  return (
    <nav className={styles.nav} aria-label={t.wizard.navAria}>
      <div className={styles.actions}>
        {showBack ? (
          <Button
            kind={Button.kinds.SECONDARY}
            size={Button.sizes.MEDIUM}
            onClick={onBack}
            disabled={loading}
          >
            {t.wizard.back}
          </Button>
        ) : null}
        <Button
          kind={Button.kinds.PRIMARY}
          size={Button.sizes.MEDIUM}
          onClick={onNext}
          disabled={!canProceed || loading}
          loading={loading}
        >
          {nextLabel ?? (isLastStep ? t.wizard.finish : t.wizard.next)}
        </Button>
      </div>
    </nav>
  );
}
